export function serialize (obj = null) {
  let string = ''
  if (obj) {
    Object.keys(obj).forEach(x => {
      if (obj[x]) {
        if (Array.isArray(obj[x])) {
          obj[x].forEach(value => {
            string += `&${x}[]=${encodeURIComponent(value)}`
          })
        } else {
          string += `&${x}=${encodeURIComponent(obj[x])}`
        }
      }
    })
  }
  return string.substr(1)
}
